module.exports = __webpack_public_path__ + "static/media/gallery4.e0525672.jpg";